export const tripTypes = [
  { value: "day-tours", labelKey: "Day Tours" },
  { value: "multiday-tours", labelKey: "Multi-day Tours" },
  // { value: "deep-stories", labelKey: "Deep Stories" },
  // { value: "promotions", labelKey: "Promotions" },
  // { value: "cycling-guide", labelKey: "Cycling Guide" },
]

export const priceRanges = [
  { value: "under-100", labelKey: "Under $100" },
  { value: "100-300", labelKey: "$100 - $300" },
  { value: "300-500", labelKey: "$300 - $500" },
  { value: "over-500", labelKey: "Over $500" },
]

export const priceRangesVI = [
  { value: "under-2500000", labelKey: "Dưới 2.500.000 đ" },
  { value: "2500000-7500000", labelKey: "2.500.000 - 7.500.000 đ" },
  { value: "7500000-12500000", labelKey: "7.500.000 - 12.500.000 đ" },
  { value: "over-12500000", labelKey: "Trên 12.500.000 đ" },
]

export const difficultyLevels = [
  { value: "Easy", labelKey: "Easy" },
  { value: "moderate", labelKey: "Moderate" },
  { value: "challenging", labelKey: "Challenging" },
  { value: "expert", labelKey: "Expert" },
]

export const durationOptions = [
  { value: "1-day", labelKey: "1 Day" },
  { value: "2-3-days", labelKey: "2-3 Days" },
  { value: "4-7-days", labelKey: "4-7 Days" },
  { value: "8-14-days", labelKey: "8-14 Days" },
  { value: "over-14-days", labelKey: "Over 14 Days" },
]
